import { useState, useEffect, useCallback } from "react";

export const useWindowSize = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useWindowResizedEffect(() => {
    const { innerWidth, innerHeight } = window;

    if (windowWidth !== innerWidth) {
      setWindowWidth(innerWidth);
    }

    if (innerHeight !== windowHeight) {
      setWindowHeight(innerHeight);
    }
  }, [windowHeight, windowWidth]);

  return { windowWidth, windowHeight };
};

export default function useWindowResizedEffect(onResize, dependencies) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleResized = useCallback(onResize, dependencies);

  useEffect(() => {
    const handleWindowResize = () => {
      const { innerWidth, innerHeight } = window;
      if (windowWidth !== innerWidth || innerHeight !== windowHeight) {
        setWindowWidth(innerWidth);
        setWindowHeight(innerHeight);

        handleResized({ width: innerWidth, height: innerHeight });
      }
    };

    window.removeEventListener("resize", handleWindowResize);
    window.addEventListener("resize", handleWindowResize);

    // Cleanup event listener on component unmounting
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [handleResized, windowWidth, windowHeight]);
}
